export default {
  CREATE_BUTTON: 'BUTTON_CREATION_CREATE_BUTTON',
  DOMAIN_TRANSACTION_TYPE: 'domain_name',
  GENERAL_TRANSACTION_TYPE: 'general_merchandise',
  VEHICLE_TRANSACTION_TYPE: 'motor_vehicle',
  BUTTON_DEFAULT_TEXT: 'Buy It Now',
  USER_STYLE_DEFAULT_TEXT: 'Buy With Escrow.com',
};
